import { useEffect, useRef } from "react";
import Map from '@arcgis/core/Map'
import MapView from '@arcgis/core/views/MapView'
import Graphic from '@arcgis/core/Graphic'
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import ArgonBox from "components/ArgonBox";
import { serverUrl } from "global/variable";

const markerSymbol = {
    type: "simple-marker",
    color: [226, 0, 40],  // Orange
    outline: {
        color: [255, 255, 255], // White
        width: 0.2
    },
    size: '5px'
};

const lineSymbol = {
    type: "simple-line",
    color: [226, 0, 0], // Orange
    width: 1
};

const generatePath = (params) => {
    let arrPath = params.split("\r\n")
    let output = [];
    arrPath.forEach(element => {
        let point = element.split("\t");
        let latLong = [parseFloat(point[1]), parseFloat(point[0])]
        output.push(latLong)
    });
    console.log(output);
    return output
}

const generatePopupTemplate = (params) => {
    return new PopupTemplate({
        title: "{nama_komponen}",
        // content: "{kode_rekening_akun} {uraian_rekening_akun}",
        content: [
            {
                type: 'text',
                text: `${params.kode_rekening_akun} ${params.uraian_rekening_akun}`
            },
            {
                type: 'media',
                mediaInfos: [
                    {
                        type: 'image',
                        caption: 'Dokumentasi',
                        value: {
                            sourceURL: params.monev === null ? '' : `${serverUrl}/uploads/monev/${params.ta}/${params.id}/${params.monev.id}/${params.monev.dokumentasi.filename}`
                        }
                    }
                ]
    
            },
        ]
    })
}

const generateGraphic = (params) => {
    let output;
    if (params.geometry_type === 'point') {
        if (params.latitude !== '') {
            console.log(parseFloat(params.latitude));
            output = new Graphic({
                geometry: {
                    type: "point",
                    latitude: parseFloat(params.latitude),
                    longitude: parseFloat(params.longitude)
                },
                symbol: markerSymbol,
                attributes: params,
                popupTemplate: generatePopupTemplate(params)
            });

        }
    }
    else if (params.geometry_type === 'polyline') {
        output = new Graphic({
            geometry: {
                type: "polyline",
                paths: generatePath(params.path)
            },
            symbol: lineSymbol,
            attributes: params,
            popupTemplate: generatePopupTemplate(params)
        });
    }
    return output;
}

const MapMultiple = ({ data, basemap }) => {
    const mapRef = useRef()
    console.log(typeof data);
    console.log(data);

    useEffect(() => {
        const map = new Map({
            basemap: basemap,
            showAttribution: false
        });

        // eslint-disable-next-line no-unused-vars
        const view = new MapView({
            container: mapRef.current,
            map: map,
            zoom: 10,
            showAttribution: false,
            center: [122.88681867119601, -5.4059342297709145], // longitude, latitude
            popup: {
                dockEnabled: false,
                dockOptions: {
                    buttonEnabled: false,
                    breakpoint: false,
                },
            },
        });

        // create empty FeatureLayer
        const layer = new GraphicsLayer();

        let graphics = [];
        let graphic;
        for (let i = 0; i < data.length; i++) {
            graphic = generateGraphic(data[i])
            graphics.push(graphic);
        }

        layer.addMany(graphics)
        map.add(layer);
    }, [basemap, data])

    const mapStyle = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        right: 0,
    };

    return (
        <ArgonBox>
            <ArgonBox className="map-container" ref={mapRef} sx={mapStyle} />
        </ArgonBox>
    );
};

export default MapMultiple;